// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"3593ccff","157":"4a636582","261":"9205f4c1","694":"ca02e7e9","918":"20a891aa","966":"a85b40e4"}[chunkId] + ".chunk.js";
};